import { render, staticRenderFns } from "./AmcInvoice.vue?vue&type=template&id=59b1798a&"
import script from "./AmcInvoice.vue?vue&type=script&lang=js&"
export * from "./AmcInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports